export default __webpack_public_path__ + "media/images/react_icons/user_landlord-36da3b92509994bc670c4bd8eac10ac2.svg";